module.exports = __webpack_public_path__ + "media/images/free-stamp-82e80b995eac0fdc3d50b160df0c4e74.png";